/**
 * Remove an index of an array without modifying the original.
 * If the index does not exist in the array, a shallow clone of the original is returned.
 * @param arr
 * @param index
 */
export const removeIndex = <T>(arr: T[], index: number) => {
  if (index < 0 || index > arr.length) {
    return [...arr];
  }

  return [...arr.slice(0, index), ...arr.slice(index + 1, arr.length)];
};
